import React from 'react';

export type TermsConditionsProps = {
  className?: string;
  style?: React.CSSProperties;
  operation?: React.ReactNode;
};

export const TermsConditions: React.FC<TermsConditionsProps> = ({
  style,
  operation = 'signing up',
  className = '',
}) => {
  return (
    <div
      style={style}
      className={` text-black text-sm flex-center flex-wrap ${className}`}
    >
      By {operation}, you accept our{' '}
      <a href='/terms' target='_blank'>
        Terms & Conditions
      </a>{' '}
      and{' '}
      <a href='/privacy' target='_blank'>
        Privacy Policy
      </a>
      . Protected by reCAPTCHA.
    </div>
  );
};
